import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const links = [{
  label: 'El sistema',
  href: '#sistema'
}, {
  label: 'Recetas',
  href: '#recetas'
}, {
  label: 'Incluye',
  href: '#incluye'
}, {
  label: 'Preguntas',
  href: '#preguntas'
}];
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = () => setIsOpen(false);
  return <header className="sticky top-0 z-50 border-b border-[#e6e4da]/80 bg-[#fcfbf7]/95 backdrop-blur" data-id="element-73">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8" data-id="element-74">
        <a href="#inicio" className="text-[13px] font-bold tracking-[0.18em] text-[#30452e]" aria-label="Código Fitness, inicio" data-id="element-75">
          CÓDIGO <span className="font-normal" data-id="element-76">FITNESS™</span>
        </a>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Navegación principal" data-id="element-77">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm text-[#556152] transition-colors hover:text-[#30452e]" data-id="element-78">
              {link.label}
            </a>)}
        </nav>
        <a href={checkoutUrl} onClick={handleCheckoutClick} className="hidden rounded-full bg-[#3f573a] px-5 py-3 text-xs font-bold tracking-[0.08em] text-white transition-colors hover:bg-[#30452e] md:inline-flex" data-id="element-79">
          COMENZAR HOY
        </a>
        <button type="button" className="rounded-full p-2 text-[#30452e] md:hidden" onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} data-id="element-80">
          {isOpen ? <XIcon size={22} data-id="element-81" /> : <MenuIcon size={22} data-id="element-82" />}
        </button>
      </div>
      {isOpen && <nav className="border-t border-[#e6e4da] bg-[#fcfbf7] px-5 py-5 md:hidden" aria-label="Navegación móvil" data-id="element-83">
          <div className="mx-auto flex max-w-7xl flex-col gap-1" data-id="element-84">
            {links.map(link => <a key={link.href} href={link.href} onClick={closeMenu} className="rounded-xl px-3 py-3 text-sm text-[#40503d] hover:bg-[#f1f2eb]" data-id="element-85">
                {link.label}
              </a>)}
            <a href={checkoutUrl} onClick={event => {
          closeMenu();
          handleCheckoutClick(event);
        }} className="mt-2 rounded-full bg-[#3f573a] px-5 py-3 text-center text-xs font-bold tracking-[0.08em] text-white" data-id="element-86">
              COMENZAR HOY
            </a>
          </div>
        </nav>}
    </header>;
}